module.exports = __webpack_public_path__ + "fonts/CashSans-Extblack.a289fe6.woff2";